export default {
  en: {
    // Error Handling
    ERROR_TITLE: "We're sorry, but an error is preventing this page from loading.",
    ERROR_MESSAGE_LINE_1:
      "Please navigate away from the page and return, then refresh and try again. If you see this message a second time while doing the same action, please report the issue via the GoodShape Service desk.",
    REPORT_ISSUE: "Report Issue",
    // Validation message
    MINIMUM_N_CHARACTERS: `{length} characters minimum`,
    INCLUDE_UPPERCASE_LETTER: `include {upperCase} uppercase letter(s)`,
    INCLUDE_LOWERCASE_LETTER: "include {lowerCase} lowercase letter(s)",
    INCLUDE_NUMBER_OR_SPECIAL_CHARACTER:
      "include {gsDigitsOrSpecialChars} number(s) or {gsDigitsOrSpecialChars} special character(s)",
    PASSWORD_CONFIRMATION_MATCHES: "password confirmation matches",

    // Forms
    CHOOSE_NEW_PASSWORD: "Choose New Password",
    CONFIRM_NEW_PASSWORD: "Confirm New Password",
    ON: "On",
    OFF: "Off",
  },
};
